import _ from 'underscore';
import { wrappedOdata as odata } from './odata-wrapper';

export const MailService = ({
  location,
  customerName,
  customerEmail,
  signOutUrl,
}) => {
  const service = {};
  const url = `${location.protocol}//${location.host}/sendemail`;

  const oDataOption = {
    contentType: 'application/json',
    SignOutUrl: signOutUrl,
  };

  service.sendMail = ({
    mailType,
    userName,
    userMail,
    userPhone,
    message,
  }) => {
    const body = {
      MailType: mailType,
      SmartPage: location.host,
      CustomerName: customerName,
      CustomerEmail: customerEmail,
      UserName: userName,
      UserEmail: userMail,
      UserPhone: userPhone,
      UserMessage: message,
    };
    const options = _.extend(
      {},
      oDataOption,
      {
        url,
        data: body,
        // No response body in this request
        dataType: 'text',
      }
    );

    return odata.post(options);
  };

  return service;
};
